import { Button, Flex } from "@chakra-ui/react";

// Shared rounded black-pill segmented toggle used across the Insights
// dashboards (Summary/Visual/Table, Annual/Quarterly, etc). Extracted so the
// supplier dashboard matches the carbon side exactly. The carbon pages carry
// their own inline copies of this markup (FootPrint.ToggleButton,
// QuartersSwitch, the CompareToggles) — those are intentionally left as-is;
// new usages should import this component.
//
// Props: options = [{ label, value, icon? }], selected, setSelected.
const PillToggle = ({ options, selected, setSelected }) => (
  <Flex bg="gray.100" borderRadius="full" p="3px" width="fit-content">
    {options.map((option) => {
      const active = selected === option.value;
      return (
        <Button
          key={option.value}
          size="xs"
          borderRadius="full"
          bg={active ? "pureBlack" : "transparent"}
          color={active ? "white" : "gray.500"}
          fontWeight={active ? "600" : "normal"}
          rightIcon={option.icon}
          onClick={() => setSelected(option.value)}
          _hover={{ bg: active ? "pureBlack" : "gray.200" }}
          px={3}
        >
          {option.label || option.value}
        </Button>
      );
    })}
  </Flex>
);

export default PillToggle;
